import {
  Button,
  FormContextWrapper,
  Input,
  Layout,
  useFormValues,
} from '@pimbutton/tast-components-lib';
import registerUser from 'actions/authentication/register';
import storeProject from 'actions/project/store';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import './Register.module.scss';

import { history } from 'components/App/components/UnauthenticatedApp';
import AuthVisual from '../AuthVisual/AuthVisual';

// TODO: add theme to project card using backend data

export default function Activate() {
  const {
    formValues,
    handleChange,
    errors,
    setErrors,
    // setFormValues,
  } = useFormValues({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    is_trial_account: 1,
    share_code: null,
    isExtern: false,
  });

  const dispatch = useReduxAction();
  const { push } = useHistory();

  const isLoggedIn = useRedux((state) => state.authentication?.isLoggedIn);

  const location = useLocation();
  const { shareCode } = useParams();
  const isExtern = location.pathname?.includes('extern-uitnodiging');

  const [isLoading, setIsLoading] = useState(false);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const values = { ...formValues };

    if (isExtern) {
      values.share_code = shareCode;
      values.isExtern = true;
      values.is_trial_account = 0;
    }
    setIsLoading(true);

    dispatch(registerUser(values))
      .catch(({ response }: { response: any }) => {
        setIsLoading(false);
        setErrors((prev: any) => ({ ...prev, ...response?.data?.errors }));
      })
      .then(() => {
        setIsLoading(false);
        history.push('/werkplaats/mijn-projecten');
      });
  }

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(
        storeProject({
          fromShare: true,
          shareCode,
        })
      ).then(() => {
        history.push('/werkplaats/mijn-projecten');
      });
    }
  }, [isLoggedIn, location]);

  return (
    <Layout
      authVisual={<AuthVisual isExtern={isExtern} shareCode={shareCode} />}
      title={isExtern ? 'EXTERN GROOW ACCOUNT' : 'Proefaccount aanmaken'}
      inputs={
        <FormContextWrapper
          onChange={handleChange}
          errors={errors}
          formValues={formValues}
        >
          <Input name="first_name" label="Voornaam" />
          <Input name="last_name" label="Achternaam" />
          <Input name="email" label="Email" />
          <Input name="password" label="Wachtwoord" />
          <Input name="password_confirmation" label="Bevestig wachtwoord" />
        </FormContextWrapper>
      }
      buttons={
        <>
          <Button inactive={isLoading} fullWidth>
            {isExtern ? 'Account aanmaken' : 'Proefaccount aanmaken'}
          </Button>
          <Button
            fullWidth
            onClick={() =>
              push(isExtern ? `/inloggen/${shareCode}` : '/inloggen')
            }
            variant="white"
          >
            Al een Groow account?
          </Button>
        </>
      }
      handleSubmit={(e) => handleSubmit(e)}
    />
  );
}
